<!-- src/app/features/register-successfully/register-successfully.component.html -->

<div
  class="container-fluid d-flex align-items-center justify-content-center min-vh-100 bg-light"
>
  <div class="col-md-8 col-lg-6">
    <!-- Logo Section -->
    <div class="text-center mb-4">
      <img
        src="https://www.sigvaris.com/globalassets/_div/sig9000_sigvaris_group_160th_logo_dual_horizontal_darkblue_rgb.svg?ref=FD8B1C8BB4"
        alt="Sigvaris Group Logo"
        class="img-fluid mb-3"
        style="max-width: 200px; height: 120px"
      />
    </div>

    <!-- Success Card -->
    <div class="card custom-card">
      <div class="card-body" style="padding-left: 25px; padding-right: 25px">
        <!-- Success Title -->
        <h2 class="card-title text-center mb-4">Registration Successful</h2>

        <!-- Success Message -->
        <div class="text-center mb-4">
          <p class="lead">
            Thank you for registering! Your account has been created
            successfully. You will soon receive an activation email.
          </p>
          <p>You will be redirected to the <strong>Login page...</strong></p>
        </div>
      </div>
    </div>
  </div>
</div>
